import styled from "styled-components";

export const AboutSectionWrapper = styled.section`
  width: 100%;
  min-height: 100%;
`;

export const AboutBanner = styled.div``;

export const H3 = styled.h3`
  font-size: 35px;
  margin: 3em auto 0.5em auto;
  text-align: center;
  text-decoration: underline;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const H3SocialMedia = styled(H3)`
  margin: 2em auto 0.5em auto;
`;

export const P = styled.p`
  text-align: center;
  text-justify: auto;
  width: 80%;
  margin: 0 auto 5em auto;
  line-height: 1.5em;
  font-size: 18px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const SocialMediaWrapper = styled.div`
  max-width: 100%;
`;

export const SocialMedia = styled.div`
  width: 100%;
  text-align: center;
`;

export const Ul = styled.ul`
  list-style: none;
  display: flex;
  justify-content: center;
  margin-bottom: 1em;
`;

export const Li = styled.li``;

export const SocialMediaLink = styled.a`
  font-size: 3em;
  text-decoration: none;
  color: black;
  margin: 0.5em;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    font-size: 2em;
  }
`;
